export const DEFAULT_CHANGE_FREQUENCY_IN_MINUTES: number = 1;
export const DEFAULT_WORK_DAYS_MASK: number = 0b1111111; // All days of the week are work days
